import ReactDOM from 'react-dom/client';
import { Provider } from "react-redux";
import App from "./App";
import "./i18n";
import * as serviceWorker from "./serviceWorker";
import store from "./store";
import axios from "axios";

window.axios = axios;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

let token = document.head.querySelector('meta[name="csrf-token"]');
if (token) {
  window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
  console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

const root = ReactDOM.createRoot(document.getElementById('rootApp'));
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);
serviceWorker.unregister()
